import { transformElements, ElementTypes } from '../../utils/html-util';
import { Fragment } from 'vue-fragment';
import Vue from 'vue';
export default Vue.extend({
    name: 'html-renderer',
    components: { Fragment },
    props: {
        htmlObject: {
            type: Object
        },
        onClick: {
            type: Function
        },
        onFocus: {
            type: Function,
            required: false
        },
        onFocusOut: {
            type: Function,
            required: false
        },
        getTabIndex: {
            type: Function,
            required: false
        },
        getTextClass: {
            type: Function
        },
        isPickTheAnswer: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            ElementTypes
        };
    },
    computed: {
        html() {
            return transformElements(this.htmlObject);
        }
    },
    methods: {
        maybeContainsHighlightClass(index, element) {
            const classList = this.maybeHighlightClass(index, element);
            return !!classList[0];
        },
        maybeAriaPressed(index, element) {
            const textClasses = this.getTextClass(index, element);
            if (textClasses === null || textClasses === void 0 ? void 0 : textClasses.includes('selectedHighlight'))
                return 'true';
            if (textClasses === null || textClasses === void 0 ? void 0 : textClasses.includes('clickableHighlight'))
                return 'false';
            return undefined;
        },
        maybeHighlightClass(index, element) {
            if (!this.getTextClass)
                return [''];
            return this.getTextClass(index, element);
        },
        elementNameSelector(name) {
            if (this.isPickTheAnswer) {
                return name && name != 'wrapper' && name != 'div' ? name : 'fragment';
            }
            return name && name != 'wrapper' ? name : 'div';
        }
    }
});
